import { LogsPage } from '../components/apiLogs/LogsPage';

export function Logs() {
  return <LogsPage />;
}